import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import emailjs from "@emailjs/browser";
import AlignBg from "../AlignBg";
import "../css/Contact.css";

const EMAILJS_SERVICE = "service_ligv2ib";
const EMAILJS_TEMPLATE = "template_4clfrfw";
const EMAILJS_PUBLIC_KEY = "aUogLAApthdH1Y6Ao";

const EXPLORER = [
  { path: "/", file: "Home.jsx" },
  { path: "/About", file: "About.jsx" },
  { path: "/Services", file: "Services.jsx" },
  { path: "/Projects", file: "Projects.jsx" },
  { path: "/Contact", file: "Contact.jsx", active: true },
];

const STATUS_META = {
  idle: { label: "Ready", className: "is-idle" },
  sending: { label: "Sending…", className: "is-sending" },
  success: { label: "Message sent ✓", className: "is-success" },
  error: { label: "Send failed ✗", className: "is-error" },
};

export const Contact = () => {
  const form = useRef();
  const [status, setStatus] = useState("idle");
  const [detail, setDetail] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();
    setStatus("sending");
    setDetail("");

    emailjs
      .sendForm(EMAILJS_SERVICE, EMAILJS_TEMPLATE, form.current, EMAILJS_PUBLIC_KEY)
      .then(() => {
        setStatus("success");
        form.current.reset();
      })
      .catch((error) => {
        console.error("EmailJS error:", error);
        setStatus("error");
        setDetail(
          [error?.status, error?.text].filter(Boolean).join(" — ") ||
            "Network error"
        );
      });
  };

  const statusMeta = STATUS_META[status];
  const statusLabel = status === "error" && detail ? detail : statusMeta.label;

  return (
    <div>
      <AlignBg name="Contact" title="Contact" kicker="// let's connect" />
      <section className="section">
        <div className="container">
          <div className="ide">
            {/* Activity bar */}
            <div className="ide__activity" aria-hidden="true">
              <span className="ide__activity-icon is-active" />
              <span className="ide__activity-icon" />
              <span className="ide__activity-icon" />
              <span className="ide__activity-icon" />
            </div>

            {/* Explorer */}
            <aside className="ide__explorer">
              <p className="ide__explorer-title">Explorer</p>
              <p className="ide__explorer-folder">PORTFOLIO</p>
              <ul className="ide__files">
                {EXPLORER.map((item) => (
                  <li key={item.file}>
                    <Link
                      to={item.path}
                      className={`ide__file ${item.active ? "is-active" : ""}`}
                    >
                      <span className="ide__file-dot" />
                      {item.file}
                    </Link>
                  </li>
                ))}
              </ul>
            </aside>

            {/* Editor */}
            <div className="ide__editor">
              <div className="ide__tabs">
                <span className="ide__tab is-active">
                  <span className="ide__tab-dot" /> contact.jsx
                </span>
              </div>

              <form ref={form} onSubmit={sendEmail} className="ide__code">
                <div className="code-line">
                  <span className="ln">1</span>
                  <span className="lc">
                    <span className="t-com">{"/**"}</span>
                  </span>
                </div>
                <div className="code-line">
                  <span className="ln">2</span>
                  <span className="lc">
                    <span className="t-com"> * New message — let&apos;s build something.</span>
                  </span>
                </div>
                <div className="code-line">
                  <span className="ln">3</span>
                  <span className="lc">
                    <span className="t-com"> * danieloshinubi@gmail.com</span>
                  </span>
                </div>
                <div className="code-line">
                  <span className="ln">4</span>
                  <span className="lc">
                    <span className="t-com">{" */"}</span>
                  </span>
                </div>
                <div className="code-line">
                  <span className="ln">5</span>
                  <span className="lc" />
                </div>
                <div className="code-line">
                  <span className="ln">6</span>
                  <span className="lc">
                    <span className="t-kw">const</span>{" "}
                    <span className="t-var">message</span>{" "}
                    <span className="t-op">=</span> <span className="t-br">{"{"}</span>
                  </span>
                </div>

                <div className="code-line">
                  <span className="ln">7</span>
                  <span className="lc indent">
                    <span className="t-key">name</span>
                    <span className="t-op">:</span>{" "}
                    <span className="t-str">&quot;</span>
                    <input
                      type="text"
                      name="from_name"
                      aria-label="Your name"
                      placeholder="your name"
                      required
                      className="code-input"
                    />
                    <span className="t-str">&quot;</span>
                    <span className="t-op">,</span>
                  </span>
                </div>

                <div className="code-line">
                  <span className="ln">8</span>
                  <span className="lc indent">
                    <span className="t-key">email</span>
                    <span className="t-op">:</span>{" "}
                    <span className="t-str">&quot;</span>
                    <input
                      type="email"
                      name="from_email"
                      aria-label="Your email"
                      placeholder="you@example.com"
                      required
                      className="code-input"
                    />
                    <span className="t-str">&quot;</span>
                    <span className="t-op">,</span>
                  </span>
                </div>

                <div className="code-line">
                  <span className="ln">9</span>
                  <span className="lc indent">
                    <span className="t-key">subject</span>
                    <span className="t-op">:</span>{" "}
                    <span className="t-str">&quot;</span>
                    <input
                      type="text"
                      name="from_subject"
                      aria-label="Subject"
                      placeholder="what's this about?"
                      required
                      className="code-input"
                    />
                    <span className="t-str">&quot;</span>
                    <span className="t-op">,</span>
                  </span>
                </div>

                <div className="code-line">
                  <span className="ln">10</span>
                  <span className="lc indent">
                    <span className="t-key">phone</span>
                    <span className="t-op">:</span>{" "}
                    <span className="t-str">&quot;</span>
                    <input
                      type="tel"
                      name="from_number"
                      aria-label="Phone"
                      placeholder="+234…"
                      pattern="[0-9+\s-]+"
                      required
                      className="code-input"
                    />
                    <span className="t-str">&quot;</span>
                    <span className="t-op">,</span>
                  </span>
                </div>

                <div className="code-line is-block">
                  <span className="ln">11</span>
                  <span className="lc indent">
                    <span className="t-key">body</span>
                    <span className="t-op">:</span>{" "}
                    <span className="t-str">{"`"}</span>
                    <textarea
                      name="message"
                      aria-label="Message"
                      placeholder="write your message here…"
                      rows="4"
                      required
                      className="code-input code-input--area"
                    />
                    <span className="t-str">{"`"}</span>
                    <span className="t-op">,</span>
                  </span>
                </div>

                <div className="code-line">
                  <span className="ln">12</span>
                  <span className="lc">
                    <span className="t-br">{"}"}</span>
                    <span className="t-op">;</span>
                  </span>
                </div>
                <div className="code-line">
                  <span className="ln">13</span>
                  <span className="lc" />
                </div>
                <div className="code-line">
                  <span className="ln">14</span>
                  <span className="lc">
                    <span className="t-var">contact</span>
                    <span className="t-op">.</span>
                    <span className="t-fn">send</span>
                    <span className="t-br">(</span>
                    <span className="t-var">message</span>
                    <span className="t-br">)</span>
                    <button
                      type="submit"
                      className="run-btn"
                      disabled={status === "sending"}
                    >
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M8 5v14l11-7z" />
                      </svg>
                      {status === "sending" ? "Running" : "Run"}
                    </button>
                  </span>
                </div>
              </form>

              {/* Status bar */}
              <div className={`ide__statusbar ${statusMeta.className}`}>
                <span className="ide__status-left">
                  <span className="ide__status-branch">⎇ main</span>
                  <span className="ide__status-state">{statusLabel}</span>
                </span>
                <span className="ide__status-right">
                  <span>Ln 14, Col 1</span>
                  <span>UTF-8</span>
                  <span>JavaScript</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
